import Add from '@mui/icons-material/Add'
import Chip from '@mui/material/Chip'

const AddNewChip = ({onClick, disabled}) => {
    return(
        <Chip icon={<Add />} label={"Add New"} onClick={onClick} size="small" disabled={disabled} />
    )
}

export default AddNewChip
